import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Text, Paragraph } from "@zillow/constellation-10";
import { useMemo } from "react";
import { commaSeparateNumber } from "../../utils/zhl-calculator.esm.js";
import { useLastValidHomeSaleProceedsCalculator, FieldConfig } from "./HomeSaleProceedsCalculator.utils.esm.js";
const summaryRowValueCss = {
  fontWeight: "{fontWeights.bold}"
};
const HomeSaleProceedsContent = () => {
  const lastValidHomeSaleProceedsCalculator = useLastValidHomeSaleProceedsCalculator();
  const {
    estimatedSellingCostResult,
    estimatedNetProceeds,
    estimatedSellingCostPercentage
  } = lastValidHomeSaleProceedsCalculator.calculations;
  const {
    desiredSellingPrice,
    remainingMortgageOwed
  } = lastValidHomeSaleProceedsCalculator.fields;
  const OUTPUTS = useMemo(() => [{
    label: "Desired selling price",
    accessor: FieldConfig.desiredSellingPrice.name
  }, {
    label: "Remaining mortgage owed",
    accessor: FieldConfig.remainingMortgageOwed.name
  }, {
    label: `Est. selling costs (${estimatedSellingCostPercentage.toFixed(2)}%)`,
    accessor: FieldConfig.estimatedSellingCost.name
  }], [estimatedSellingCostPercentage]);
  return /* @__PURE__ */ jsxs(Box, { css: {
    flex: 1,
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%"
  }, "aria-live": "polite", "aria-atomic": "true", children: [
    /* @__PURE__ */ jsx(Text, { asChild: true, textStyle: "heading-sm", css: {
      fontWeight: "{fontWeights.bold}",
      color: "text.neutral"
    }, children: /* @__PURE__ */ jsx("h2", { children: "Estimated net proceeds" }) }),
    /* @__PURE__ */ jsxs(Text, { css: {
      display: "block",
      color: "green.500",
      margin: "{spacing.loose}"
    }, textStyle: "heading-lg", children: [
      "$",
      commaSeparateNumber(estimatedNetProceeds)
    ] }),
    OUTPUTS.map(({
      label,
      accessor
    }, index) => /* @__PURE__ */ jsxs(Box, { css: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      paddingBottom: "{spacing.default}",
      marginBottom: "{spacing.default}",
      width: "80%",
      ...index !== OUTPUTS.length - 1 ? {
        borderBottom: "1px solid {colors.border.muted}"
      } : {}
    }, children: [
      /* @__PURE__ */ jsx(Paragraph, { textStyle: "body", children: label }),
      accessor === FieldConfig.estimatedSellingCost.name ? /* @__PURE__ */ jsxs(Text, { textStyle: "body", css: summaryRowValueCss, children: [
        "$",
        commaSeparateNumber(estimatedSellingCostResult)
      ] }) : accessor === FieldConfig.remainingMortgageOwed.name ? /* @__PURE__ */ jsxs(Text, { textStyle: "body", css: summaryRowValueCss, children: [
        "$",
        commaSeparateNumber(remainingMortgageOwed)
      ] }) : /* @__PURE__ */ jsxs(Text, { textStyle: "body", css: summaryRowValueCss, children: [
        "$",
        commaSeparateNumber(desiredSellingPrice)
      ] })
    ] }, accessor))
  ] });
};
export {
  HomeSaleProceedsContent as default
};
